<template>
  <div class="page adviser-page">
    <div class="page__bd">
      <div v-if="hasPartner" class="form-preview weui-form-preview">
        <div class="weui-form-preview__hd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label weui-form-preview__title">{{
              partner.enuu ? inviteUser.name : partner.name
            }}</label>
            <!-- 如果非企业合伙人，inviteUser对象只有uu是正常返回的，其余都是空的 -->
            <div
              v-if="!partner.enuu && partner.level"
              class="partner-level"
              :class="'partner-level-' + partner.level"
            ></div>
            <!-- 如果企业合伙人，inviteUser对象正常返回 -->
            <div
              v-else-if="partner.enuu && inviteUser.level"
              class="partner-level"
              :class="'partner-level-' + inviteUser.level"
            ></div>
          </div>
        </div>
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">UU号</label>
            <span class="weui-form-preview__value">{{ inviteUser.uu }}</span>
          </div>
          <div v-if="partner.enuu" class="weui-form-preview__item">
            <label class="weui-form-preview__label">企业</label>
            <span class="weui-form-preview__value">{{ partner.name }}
              <span
              v-if="partner.level"
              class="partner-level"
              :class="'partner-level-' + partner.level"
            ></span>
            </span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">手机</label>
            <span class="weui-form-preview__value">{{
              partner.enuu ? inviteUser.mobile : partner.mobile
            }}</span>
          </div>
        </div>
      </div>

      <div v-else class="weui-msg">
        <div class="weui-msg__icon-area">
          <i class="weui-icon-warn weui-icon_msg"></i>
        </div>
        <div class="weui-msg__text-area">
          <p class="weui-msg__desc">暂无专属顾问</p>
        </div>
        <div class="weui-msg__opr-area">
          <p class="weui-btn-area"></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    this.loadData();
  },
  data() {
    return {
      hasPartner: false,
      partner: {},
      inviteUser: {},
    };
  },
  methods: {
    loadData() {
      const me = this;
      me.$loading({
        url: "/api/account/partner/customer/status",
      }).then(function (res) {
        if (res.success) {
          const data = res.data;
          if (data && data.hasPartner) {
            me.hasPartner = true;
            me.inviteUser = data.customer.followUser || data.customer.inviteUser;
            me.partner = data.customer.partner;
          }
        }
      });
    },
  },
};
</script>

<style scoped>
.adviser-page .weui-form-preview__label,
.adviser-page .weui-form-preview__value {
  font-weight: 400;
  font-size: 17px;
}

.adviser-page .weui-form-preview__title {
  color: var(--weui-FG-0);
}

.partner-level {
  display: inline-block;
  margin: 0 0 2px 5px;
  vertical-align: middle;
  background-image: url("../../assets/images/partner_level.png");
  background-repeat: no-repeat;
  width: 24px;
  height: 24px;
  background-size: cover;
}

.partner-level-10 {
  background-position: -48px 0;
}

.partner-level-20 {
  background-position: -24px 0;
}

.partner-level-30 {
  background-position: 0 0;
}
</style>